/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";

const DataBank = ({ data, type }) => {
  return (
    <>
      <div className='container'>
        <div className='callback fail'>
          <img src='/images/fail.png' alt='fail' />
          <h4 className='text-center'>پرداخت شما با مشکل مواجه شده است</h4>
          <div className='bottom-callback'>
            {type == 1 && (
              <a href='/shop' className='btn_callback'>
                بازگشت به سایت
              </a>
            )}
            {type == 2 && data && (
              <a
                href={`/document/${data.document._id}`}
                className='btn_callback'
              >
                بازگشت به سایت
              </a>
            )}
            {type == 3 && data && (
              <a
                href={`/detail-lawyer/${data.lawyer._id}
                `}
                className='btn_callback'
              >
                بازگشت به سایت
              </a>
            )}
            {(type == 3 || type == 2) && !data && (
              <a href='/' className='btn_callback'>
                بازگشت به سایت
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default DataBank;
